import React from 'react';

import Component from '../../../Component';
import { withResizer } from '../../../../HoCs';
import styles from './styles';

class WhyJoinOyo extends Component {

    styles = styles;

    render = () => <div style={{ ...this.gs('container'), ...this.props.style }}>
        <img src={this.props.image} alt={this.props.title} style={{...this.gs('image'), ...this.props.imageStyle}} />
        <div style={{...this.gs('title'), ...this.props.titleStyle}}>{this.props.title}</div>
        <div style={{...this.gs('description'), ...this.props.descriptionStyle}}>{this.props.description}</div>
        {typeof this.props.onMore === 'function' && <div style={{...this.gs('view_more'), ...this.props.viewMoreStyle}} onClick={this.props.onMore}>View More</div>}
    </div>;

}

export default withResizer(WhyJoinOyo);
